import { query as fbQuery, collection, collectionGroup, getDoc, getDocs, limit, onSnapshot, orderBy, where } from "firebase/firestore";
import { db } from "./firebase.utils";

// Retrieves a unique document from Firestore
export async function getUniqueDocumentFromFirestore(e) {
  let docRef;

  if (e.path) {
    docRef = doc(db, e.path);
  }

  if (e.once) {
    getDoc(docRef).then(doc => {
      if (doc.exists) {
        const data = doc.data();
        e.callback(data);
      }
    });
    return;
  }

  const unsubscribe = onSnapshot(docRef, doc => {
    const data = doc.data();
    e.callback(data, doc.id)
  });
  e.handleListener(unsubscribe);

}

// Retrieves a collection from Firestore
export async function getCollectionFromFirestore(e) {
  let collectionRef;

  if (e.path && e.collectionGroup) {
    collectionRef = collectionGroup(db, e.path);
  }
  else if (e.path) {
    collectionRef = collection(db, e.path);
  }

  if (e.once) {
    const docObj = {};
    getDocs(collectionRef).then(snapshot => {
      snapshot.forEach(doc => {
        docObj[doc.id] = doc.data();
      });
    });
    e.callback(docObj);
    return;
  }

  const unsubscribe = onSnapshot(collectionRef, snapshot => {
    snapshot.forEach(doc => {
      const data = doc.data();
      e.callback(data, doc.id);
    })
  });
  e.handleListener(unsubscribe);
}

// Retrieves documents from Firestore based on query parameters
export async function getQueryFromFirestore(e) {
  let queryRef;
  let whereArr = [];
  if (e.queryArray) {
    e.queryArray.forEach(q => {
      whereArr.push(where(q.field, q.operator, q.value));
    });
  }

  if (e.loadLimit) {
    whereArr.push(limit(e.loadLimit));
  }

  if (e.orderBy) {
    whereArr.push(e.orderBy.direction === 'desc' ?
      orderBy(e.orderBy.field, 'desc') :
      orderBy(e.orderBy.field, 'asc')
    );
  }

  if (e.path && e.collectionGroup) {
    queryRef = fbQuery(collectionGroup(db, e.path), ...whereArr);
  }
  else if (e.path) {
    queryRef = fbQuery(collection(db, e.path), ...whereArr);
  }

  if (e.once) {
    const docObj = {};
    getDocs(queryRef).then(snapshot => {
      snapshot.forEach(doc => {
        docObj[doc.id] = doc.data();
      });
      e.callback(docObj);
    });
    return;
  }

  const unsubscribe = onSnapshot(queryRef, snapshot => {
    snapshot.forEach(doc => {
      e.callback(doc.data(), doc.id);
    });
  });
  e.handleListener(unsubscribe);
}